/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationStatisticsRequest extends models.RecommendationsFilterBase {
    getFixupPrototypeFunction() { return RecommendationStatisticsRequest.fixupPrototype; }

    static newInstance(model: Partial<RecommendationStatisticsRequest>): RecommendationStatisticsRequest {
        let obj = Object.assign(new RecommendationStatisticsRequest(), model);
        RecommendationStatisticsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationStatisticsRequest>): RecommendationStatisticsRequest {
        if (!model) return null;
        return RecommendationStatisticsRequest.newInstance(<RecommendationStatisticsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationStatisticsRequest) {
        if (!obj) return;

        models.RecommendationStatisticsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationStatisticsRequest): boolean {
        if (models.RecommendationsFilterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationStatisticsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * workflow sys id for which the rules are required
     */
    workflow_sys_id: string;

}
